module.exports = __webpack_public_path__ + "static/img/home9.8db05d6c.png";